module.exports = "/static/assets/4d89d58309c13d68fae3a79c7e99a77f.png";